<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-10-27 09:19:38
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-11-10 08:50:43
 * @FilePath: \minipro-manger\src\views\Login\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="loginBody">
    <div class="loginFromBox">
      <div class="title">系统登录</div>
      <div>
        <el-input placeholder="请输入账号" v-model="username">
          <i slot="prefix" class="el-input__icon el-icon-user"></i>
        </el-input>
        <el-input placeholder="请输入密码" v-model="password" show-password style="margin-top:30px">
          <i slot="prefix" class="el-input__icon el-icon-goods"></i>
        </el-input>
        <el-button type="primary" style="margin-top:30px;width:100%" @click="submit">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    submit() {
      this.$router.push("/UserFeedback");
    }
  }
};
</script>

<style>
.loginBody {
  width: 100vw;
  height: 100vh;
  background-color: #2d3a4b;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: 300px; */
}
.loginFromBox {
  width: 400px;
  height: 300px;
  /* background-color: aqua; */
  padding: 0 10px;
}
.title {
  width: 100%;
  height: 50px;
  font-size: 26px;
  font-weight: 800;
  color: white;
}
</style>